<template>
  <div class="container" v-if="list.length > 0">
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="category">
          <div class="left">
            <a class="category-top">{{ name }}</a>
            <a class="category-bottom">{{ enname }}</a>
          </div>
          <div class="right tip">
                    菜肴图片仅供参考
                </div>
        </div>
      </div>
      <div class="panel-body" style="padding: 0px">
        <ul class="list-group  pdd">
          <li class="list-group-item" v-for="(item, index) in list">
            <van-row type="flex">
              <van-col span="12" @click="showPic(item)">
                <van-swipe
                  v-if="item.gimages && item.gimages.length > 0"
                  :autoplay="3000"
                  height="120"
                >
                  <van-swipe-item v-for="ite in item.gimages" :key="index">
                    <!-- <img v-lazy="ite.img_urls" /> -->
                    <van-image :src="ite.img_urls">
                  <template v-slot:loading>
                      <van-loading type="spinner" size="30" />
                  </template>
                      </van-image>
                  </van-swipe-item>
                </van-swipe>
              </van-col>
              <van-col span="12">
                <ul class="room-info">
                  <li>
                    <strong>{{ item.DishName }}</strong>
                  </li>
                  <li><b>风味：{{ item.Flavour?item.Flavour:'暂无' }}</b></li>
                  <li><b>食材：{{ item.Material }}</b></li>
                  <li><strong class="price"
                      >参考价: ￥{{ item.Price.replace(".00", "") }}</strong
                    ></li>
                </ul>
              </van-col>
            </van-row>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from "vant";

export default {
  data() {
    return {
      show: false,
    };
  },
  props: {
    list: {
      type: Array || Object,
      require: true,
    },
    name: {
      type: String,
      default: "特色菜肴",
    },
    enname: {
      type: String,
      default: "Dishes",
    },
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  mounted: function () {},
  methods: {
    showPic(item) {
      let images = [];
      for (let i in item.gimages) {
        images[i] = item.gimages[i]["img_urls"];
      }
      if (images.length == 0) return;
      ImagePreview({
        images,
        closeable: true,
      });
    },
  },
};
</script>
<style>
.room-info li strong {
  font-weight: 800;
}
.room-info li b{
  font-size: 12px;
}
.list-group-item{
  margin-bottom: 10px !important
}
.room-info li:first-child{
  color: #232a31;
}
.pdd{
  padding: 6px 12px;
}
.pdd li{
  /* margin-bottom: 6px; */
}
</style>
